<template>
    <li class="tool nav-item dropdown no-sm-border border-right d-block main-user-block w-100 badge-container">
        <a
            class="nav-link dropdown-toggle bg-white h-100 align-items-center d-flex w-100 h-100"
            href="#"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <span
                class="d-none d-xs-none d-sm-none d-md-flex d-lg-flex d-xl-flex justify-content-between align-items-center w-100 h-100"
            >
                <template v-if="!isSatAdmin && !isApi2Convert">
                    <a
                        @click="handleCreditsNav"
                        class="p-0 m-0 border-right border-bottom h-100 d-flex align-items-center justify-content-center"
                    >
                        <div
                            v-if="isCreditsInAllSatsEnabled"
                            class="user-badge"
                            :class="userBadgeBg"
                            @mouseover="handleHideDropDown($event)"
                        >
                            <div class="w-100">
                                <div class="user-credits">{{ this.availableCredit }}<CoinSVG /></div>
                                <span class="text-uppercase" v-if="isUserRegistered">{{ 'FREE TRIAL' | trans }}</span>
                                <span class="text-uppercase" v-if="isUserPremium">{{ userProduct | trans }}</span>
                                <span class="text-uppercase" v-if="isUserEducational">{{ 'EDUCATION' | trans }}</span>
                            </div>
                            <div class="bg-white h-100 user-icon">
                                <svg
                                    width="24"
                                    height="28"
                                    viewBox="0 0 24 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M23.08 22.4039C22.4918 20.9114 21.6381 19.5557 20.5666 18.4124C19.4983 17.2657 18.2328 16.3515 16.84 15.7201C16.8275 15.7135 16.815 15.7101 16.8026 15.7034C18.7454 14.2003 20.0083 11.752 20.0083 8.98958C20.0083 4.41347 16.5469 0.705811 12.2746 0.705811C8.00227 0.705811 4.54078 4.41347 4.54078 8.98958C4.54078 11.752 5.80376 14.2003 7.74656 15.7068C7.73408 15.7135 7.72161 15.7168 7.70914 15.7235C6.31207 16.3548 5.05844 17.26 3.98258 18.4157C2.91204 19.56 2.0585 20.9154 1.4691 22.4073C0.890067 23.8678 0.577784 25.4337 0.54915 27.0201C0.548318 27.0558 0.554156 27.0913 0.56632 27.1245C0.578484 27.1577 0.596729 27.1879 0.619978 27.2134C0.643227 27.239 0.671012 27.2592 0.701693 27.2731C0.732375 27.2869 0.765334 27.2941 0.798627 27.294H2.6697C2.80692 27.294 2.91606 27.1771 2.91918 27.0335C2.98155 24.4548 3.94827 22.0399 5.65719 20.2094C7.42536 18.3155 9.77356 17.2734 12.2746 17.2734C14.7756 17.2734 17.1238 18.3155 18.8919 20.2094C20.6009 22.0399 21.5676 24.4548 21.6299 27.0335C21.6331 27.1805 21.7422 27.294 21.8794 27.294H23.7505C23.7838 27.2941 23.8168 27.2869 23.8474 27.2731C23.8781 27.2592 23.9059 27.239 23.9291 27.2134C23.9524 27.1879 23.9706 27.1577 23.9828 27.1245C23.995 27.0913 24.0008 27.0558 24 27.0201C23.9688 25.4235 23.6601 23.8703 23.08 22.4039ZM12.2746 14.7348C10.8432 14.7348 9.49601 14.1369 8.48251 13.0513C7.46901 11.9657 6.91081 10.5227 6.91081 8.98958C6.91081 7.45642 7.46901 6.01344 8.48251 4.92786C9.49601 3.84229 10.8432 3.24439 12.2746 3.24439C13.7059 3.24439 15.0531 3.84229 16.0666 4.92786C17.0801 6.01344 17.6383 7.45642 17.6383 8.98958C17.6383 10.5227 17.0801 11.9657 16.0666 13.0513C15.0531 14.1369 13.7059 14.7348 12.2746 14.7348Z"
                                        fill="#1E1E1E"
                                    />
                                </svg>
                            </div>
                        </div>
                        <div
                            v-else
                            class="user-badge align-items-center"
                            :class="userBadgeBg"
                            @mouseover="handleHideDropDown($event)"
                        >
                            <div class="w-100">
                                <span class="text-uppercase" v-if="isUserRegistered">{{ 'FREE' | trans }}</span>
                                <span v-if="isUserPremium">{{ 'Professional' | trans }}</span>
                                <span class="text-uppercase" v-if="isUserEducational">{{ 'EDUCATION' | trans }}</span>
                            </div>
                            <div class="bg-white h-100 user-icon">
                                <svg
                                    width="24"
                                    height="28"
                                    viewBox="0 0 24 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M23.08 22.4039C22.4918 20.9114 21.6381 19.5557 20.5666 18.4124C19.4983 17.2657 18.2328 16.3515 16.84 15.7201C16.8275 15.7135 16.815 15.7101 16.8026 15.7034C18.7454 14.2003 20.0083 11.752 20.0083 8.98958C20.0083 4.41347 16.5469 0.705811 12.2746 0.705811C8.00227 0.705811 4.54078 4.41347 4.54078 8.98958C4.54078 11.752 5.80376 14.2003 7.74656 15.7068C7.73408 15.7135 7.72161 15.7168 7.70914 15.7235C6.31207 16.3548 5.05844 17.26 3.98258 18.4157C2.91204 19.56 2.0585 20.9154 1.4691 22.4073C0.890067 23.8678 0.577784 25.4337 0.54915 27.0201C0.548318 27.0558 0.554156 27.0913 0.56632 27.1245C0.578484 27.1577 0.596729 27.1879 0.619978 27.2134C0.643227 27.239 0.671012 27.2592 0.701693 27.2731C0.732375 27.2869 0.765334 27.2941 0.798627 27.294H2.6697C2.80692 27.294 2.91606 27.1771 2.91918 27.0335C2.98155 24.4548 3.94827 22.0399 5.65719 20.2094C7.42536 18.3155 9.77356 17.2734 12.2746 17.2734C14.7756 17.2734 17.1238 18.3155 18.8919 20.2094C20.6009 22.0399 21.5676 24.4548 21.6299 27.0335C21.6331 27.1805 21.7422 27.294 21.8794 27.294H23.7505C23.7838 27.2941 23.8168 27.2869 23.8474 27.2731C23.8781 27.2592 23.9059 27.239 23.9291 27.2134C23.9524 27.1879 23.9706 27.1577 23.9828 27.1245C23.995 27.0913 24.0008 27.0558 24 27.0201C23.9688 25.4235 23.6601 23.8703 23.08 22.4039ZM12.2746 14.7348C10.8432 14.7348 9.49601 14.1369 8.48251 13.0513C7.46901 11.9657 6.91081 10.5227 6.91081 8.98958C6.91081 7.45642 7.46901 6.01344 8.48251 4.92786C9.49601 3.84229 10.8432 3.24439 12.2746 3.24439C13.7059 3.24439 15.0531 3.84229 16.0666 4.92786C17.0801 6.01344 17.6383 7.45642 17.6383 8.98958C17.6383 10.5227 17.0801 11.9657 16.0666 13.0513C15.0531 14.1369 13.7059 14.7348 12.2746 14.7348Z"
                                        fill="#1E1E1E"
                                    />
                                </svg>
                            </div>
                        </div>
                    </a>
                </template>
                
                <span class="d-md-flex align-items-center menu-badge mx-2" @mouseover="handleShowDropDown($event)">
                    <span class="hidden-mobile">{{ 'Menu' | trans }}</span>
                    <i class="fa fa-bars fg-normal fa-lg"></i>
                </span>
            </span>
            <span class="d-flex align-items-center d-md-none">
                <template v-if="!isSatAdmin && !isApi2Convert">
                    <a
                        @click="handleCreditsNav"
                        class="p-0 m-0 pr-1 h-100 d-flex align-items-center justify-content-center"
                    >
                        <div
                            v-if="isCreditsInAllSatsEnabled"
                            class="user-badge"
                            :class="userBadgeBg"
                            @mouseover="handleHideDropDown($event)"
                        >
                            <div class="w-100">
                                <div class="user-credits">{{ this.availableCredit }}<CoinSVG /></div>
                                <span class="text-uppercase" v-if="isUserRegistered">{{ 'FREE' | trans }}</span>
                                <span class="text-uppercase" v-if="isUserPremium">{{ userProduct | trans }}</span>
                                <span class="text-uppercase" v-if="isUserEducational">{{ 'EDUCATION' | trans }}</span>
                            </div>
                            <div class="bg-white h-100 user-icon">
                                <svg
                                    width="24"
                                    height="28"
                                    viewBox="0 0 24 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M23.08 22.4039C22.4918 20.9114 21.6381 19.5557 20.5666 18.4124C19.4983 17.2657 18.2328 16.3515 16.84 15.7201C16.8275 15.7135 16.815 15.7101 16.8026 15.7034C18.7454 14.2003 20.0083 11.752 20.0083 8.98958C20.0083 4.41347 16.5469 0.705811 12.2746 0.705811C8.00227 0.705811 4.54078 4.41347 4.54078 8.98958C4.54078 11.752 5.80376 14.2003 7.74656 15.7068C7.73408 15.7135 7.72161 15.7168 7.70914 15.7235C6.31207 16.3548 5.05844 17.26 3.98258 18.4157C2.91204 19.56 2.0585 20.9154 1.4691 22.4073C0.890067 23.8678 0.577784 25.4337 0.54915 27.0201C0.548318 27.0558 0.554156 27.0913 0.56632 27.1245C0.578484 27.1577 0.596729 27.1879 0.619978 27.2134C0.643227 27.239 0.671012 27.2592 0.701693 27.2731C0.732375 27.2869 0.765334 27.2941 0.798627 27.294H2.6697C2.80692 27.294 2.91606 27.1771 2.91918 27.0335C2.98155 24.4548 3.94827 22.0399 5.65719 20.2094C7.42536 18.3155 9.77356 17.2734 12.2746 17.2734C14.7756 17.2734 17.1238 18.3155 18.8919 20.2094C20.6009 22.0399 21.5676 24.4548 21.6299 27.0335C21.6331 27.1805 21.7422 27.294 21.8794 27.294H23.7505C23.7838 27.2941 23.8168 27.2869 23.8474 27.2731C23.8781 27.2592 23.9059 27.239 23.9291 27.2134C23.9524 27.1879 23.9706 27.1577 23.9828 27.1245C23.995 27.0913 24.0008 27.0558 24 27.0201C23.9688 25.4235 23.6601 23.8703 23.08 22.4039ZM12.2746 14.7348C10.8432 14.7348 9.49601 14.1369 8.48251 13.0513C7.46901 11.9657 6.91081 10.5227 6.91081 8.98958C6.91081 7.45642 7.46901 6.01344 8.48251 4.92786C9.49601 3.84229 10.8432 3.24439 12.2746 3.24439C13.7059 3.24439 15.0531 3.84229 16.0666 4.92786C17.0801 6.01344 17.6383 7.45642 17.6383 8.98958C17.6383 10.5227 17.0801 11.9657 16.0666 13.0513C15.0531 14.1369 13.7059 14.7348 12.2746 14.7348Z"
                                        fill="#1E1E1E"
                                    />
                                </svg>
                            </div>
                        </div>
                        <div
                            v-else
                            class="user-badge align-items-center"
                            :class="userBadgeBg"
                            @mouseover="handleHideDropDown($event)"
                        >
                            <div class="w-100">
                                <span class="text-uppercase" v-if="isUserRegistered">{{ 'FREE' | trans }}</span>
                                <span v-if="isUserPremium">{{ 'Professional' | trans }}</span>
                                <span class="text-uppercase" v-if="isUserEducational">{{ 'EDUCATION' | trans }}</span>
                            </div>
                            <div class="bg-white h-100 user-icon">
                                <svg
                                    width="24"
                                    height="28"
                                    viewBox="0 0 24 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M23.08 22.4039C22.4918 20.9114 21.6381 19.5557 20.5666 18.4124C19.4983 17.2657 18.2328 16.3515 16.84 15.7201C16.8275 15.7135 16.815 15.7101 16.8026 15.7034C18.7454 14.2003 20.0083 11.752 20.0083 8.98958C20.0083 4.41347 16.5469 0.705811 12.2746 0.705811C8.00227 0.705811 4.54078 4.41347 4.54078 8.98958C4.54078 11.752 5.80376 14.2003 7.74656 15.7068C7.73408 15.7135 7.72161 15.7168 7.70914 15.7235C6.31207 16.3548 5.05844 17.26 3.98258 18.4157C2.91204 19.56 2.0585 20.9154 1.4691 22.4073C0.890067 23.8678 0.577784 25.4337 0.54915 27.0201C0.548318 27.0558 0.554156 27.0913 0.56632 27.1245C0.578484 27.1577 0.596729 27.1879 0.619978 27.2134C0.643227 27.239 0.671012 27.2592 0.701693 27.2731C0.732375 27.2869 0.765334 27.2941 0.798627 27.294H2.6697C2.80692 27.294 2.91606 27.1771 2.91918 27.0335C2.98155 24.4548 3.94827 22.0399 5.65719 20.2094C7.42536 18.3155 9.77356 17.2734 12.2746 17.2734C14.7756 17.2734 17.1238 18.3155 18.8919 20.2094C20.6009 22.0399 21.5676 24.4548 21.6299 27.0335C21.6331 27.1805 21.7422 27.294 21.8794 27.294H23.7505C23.7838 27.2941 23.8168 27.2869 23.8474 27.2731C23.8781 27.2592 23.9059 27.239 23.9291 27.2134C23.9524 27.1879 23.9706 27.1577 23.9828 27.1245C23.995 27.0913 24.0008 27.0558 24 27.0201C23.9688 25.4235 23.6601 23.8703 23.08 22.4039ZM12.2746 14.7348C10.8432 14.7348 9.49601 14.1369 8.48251 13.0513C7.46901 11.9657 6.91081 10.5227 6.91081 8.98958C6.91081 7.45642 7.46901 6.01344 8.48251 4.92786C9.49601 3.84229 10.8432 3.24439 12.2746 3.24439C13.7059 3.24439 15.0531 3.84229 16.0666 4.92786C17.0801 6.01344 17.6383 7.45642 17.6383 8.98958C17.6383 10.5227 17.0801 11.9657 16.0666 13.0513C15.0531 14.1369 13.7059 14.7348 12.2746 14.7348Z"
                                        fill="#1E1E1E"
                                    />
                                </svg>
                            </div>
                        </div>
                    </a>
                </template>

                <span @mouseover="handleShowDropDown($event)">
                    <span class="hidden-mobile">{{ 'Menu' | trans }}</span>
                    <i class="fa fa-bars fg-normal"></i>
                </span>
            </span>
        </a>

        <div
            @mouseover="handleShowDropDown($event)"
            @mouseout="handleHideDropDown($event)"
            v-if="showDropDown"
            style="padding: 20px 10px;"
            id="dropdown-menu-hover"
            class="dropdown-menu main-user-dropdown dropdown-menu-right w-100 border bg-white border-top"
        >
            <!-- TODO why in tarnation is this a list element when there are no list items inside? -->
            <div class="list-unstyled d-flex flex-column gap-20">
                <template v-if="!isSatAdmin">
                    <div class="d-flex flex-column gap-5">
                        <div
                            v-if="shouldShowUpgradeBox"
                            class="card text-white mt-1 br-4"
                            :class="{
                                'bg-premium-dark': !shouldShowEducationalClaim,
                                'bg-education-i': shouldShowEducationalClaim,
                            }"
                        >
                            <div class="card-body p-3">
                                <p class="mb-3" v-html="descriptionUpgradeBox"></p>
                                <!-- TODO replace this with an actual button (exceedingly difficult right now due to css interference) -->
                                <a
                                    data-user-button-upgrade
                                    class="btn btn-block btn-warning text-dark d-flex align-items-center justify-content-center"
                                    @click.stop.prevent="clickUpgradeButton"
                                    href="#"
                                    >{{ textUpgradeButton }}</a
                                >
                            </div>
                        </div>

                        <div v-if="shouldShowBuyMore">
                            <a
                                data-user-button-upgrade
                                class="btn btn-block btn-warning text-dark"
                                @click.stop.prevent="clickBuyMoreCredits"
                                href="#"
                            >
                                <span class="w-100 gap-30 d-flex align-items-center px-4">
                                    <i class="fa fa-chevron-right" />
                                    <strong>{{ 'Get more Credits' | trans }}</strong>
                                </span>
                            </a>
                        </div>

                        <div v-if="showSale">
                            <div
                                class="card premium-bg text-white mt-1"
                                style="border-radius: 4px"
                                v-if="isUserRegistered && !isApi2Convert"
                            >
                                <div class="card-body p-3">
                                    {{
                                        'Use some of our finest tools for a low cost. Hurry, the offer expires on %sale_end%.'
                                            | trans({ '%sale_end%': 'November 30, 2022' })
                                    }}
                                    <a
                                        data-user-button-upgrade
                                        class="btn btn-block btn-warning text-dark mb-2"
                                        @click.stop.prevent="clickUpgradeButton"
                                        href="#"
                                        >{{ textSaleButton }}</a
                                    >
                                    <a
                                        :href="linkSale"
                                        class="text-white p-2 text-underline"
                                        style="color: #fff !important"
                                        >{{ 'Learn more' | trans }}</a
                                    >
                                </div>
                            </div>
                        </div>

                        <a class="dropdown-item hidden-in-user-area header-dropdown-item" :href="linkRecentTasks">
                            <div class="d-flex gap-20 align-items-center">
                                <div class="icon-container">
                                    <svg width="28" height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M25.0943 13.7864V5.45455C25.0943 4.73123 24.8069 4.03754 24.2955 3.52607C23.784 3.01461 23.0903 2.72727 22.367 2.72727H16.667C16.0943 1.14545 14.5943 0 12.8216 0C11.0488 0 9.54882 1.14545 8.9761 2.72727H3.2761C1.7761 2.72727 0.548828 3.95455 0.548828 5.45455V24.5455C0.548828 25.2688 0.836165 25.9625 1.34763 26.4739C1.85909 26.9854 2.55278 27.2727 3.2761 27.2727H11.6079C13.3261 28.9636 15.6715 30 18.2761 30C23.5534 30 27.8215 25.7318 27.8215 20.4545C27.8215 17.85 26.7852 15.5045 25.0943 13.7864ZM12.8216 2.72727C13.5715 2.72727 14.1852 3.34091 14.1852 4.09091C14.1852 4.84091 13.5715 5.45455 12.8216 5.45455C12.0716 5.45455 11.4579 4.84091 11.4579 4.09091C11.4579 3.34091 12.0716 2.72727 12.8216 2.72727ZM3.2761 24.5455V5.45455H6.00337V8.18182H19.6397V5.45455H22.367V11.8364C20.5883 10.9913 18.5916 10.7174 16.6511 11.0524C14.7105 11.3873 12.9212 12.3147 11.5287 13.7072C10.1362 15.0996 9.20888 16.889 8.87392 18.8295C8.53896 20.7701 8.81282 22.7668 9.65792 24.5455H3.2761ZM18.2761 27.2727C14.5125 27.2727 11.4579 24.2182 11.4579 20.4545C11.4579 16.6909 14.5125 13.6364 18.2761 13.6364C22.0397 13.6364 25.0943 16.6909 25.0943 20.4545C25.0943 24.2182 22.0397 27.2727 18.2761 27.2727ZM18.9579 20.7955L22.8579 23.1L21.8352 24.7636L16.9125 21.8182V15H18.9579V20.7955Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                </div>
                                <div>{{ 'Recent Tasks' | trans }}</div>
                            </div>
                        </a>
                    </div>

                    <div class="d-flex flex-column gap-5">
                        <strong>{{ 'Account' | trans }}</strong>
                        <a class="dropdown-item hidden-in-user-area header-dropdown-item" :href="linkDashboard">
                            <div class="d-flex gap-20 align-items-center">
                                <div class="icon-container">
                                    <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M23.08 22.4039C22.4918 20.9114 21.6381 19.5557 20.5666 18.4124C19.4983 17.2657 18.2328 16.3515 16.84 15.7201C16.8275 15.7135 16.815 15.7101 16.8026 15.7034C18.7454 14.2003 20.0083 11.752 20.0083 8.98958C20.0083 4.41347 16.5469 0.705811 12.2746 0.705811C8.00227 0.705811 4.54078 4.41347 4.54078 8.98958C4.54078 11.752 5.80376 14.2003 7.74656 15.7068C7.73408 15.7135 7.72161 15.7168 7.70914 15.7235C6.31207 16.3548 5.05844 17.26 3.98258 18.4157C2.91204 19.56 2.0585 20.9154 1.4691 22.4073C0.890067 23.8678 0.577784 25.4337 0.54915 27.0201C0.548318 27.0558 0.554156 27.0913 0.56632 27.1245C0.578484 27.1577 0.596729 27.1879 0.619978 27.2134C0.643227 27.239 0.671012 27.2592 0.701693 27.2731C0.732375 27.2869 0.765334 27.2941 0.798627 27.294H2.6697C2.80692 27.294 2.91606 27.1771 2.91918 27.0335C2.98155 24.4548 3.94827 22.0399 5.65719 20.2094C7.42536 18.3155 9.77356 17.2734 12.2746 17.2734C14.7756 17.2734 17.1238 18.3155 18.8919 20.2094C20.6009 22.0399 21.5676 24.4548 21.6299 27.0335C21.6331 27.1805 21.7422 27.294 21.8794 27.294H23.7505C23.7838 27.2941 23.8168 27.2869 23.8474 27.2731C23.8781 27.2592 23.9059 27.239 23.9291 27.2134C23.9524 27.1879 23.9706 27.1577 23.9828 27.1245C23.995 27.0913 24.0008 27.0558 24 27.0201C23.9688 25.4235 23.6601 23.8703 23.08 22.4039ZM12.2746 14.7348C10.8432 14.7348 9.49601 14.1369 8.48251 13.0513C7.46901 11.9657 6.91081 10.5227 6.91081 8.98958C6.91081 7.45642 7.46901 6.01344 8.48251 4.92786C9.49601 3.84229 10.8432 3.24439 12.2746 3.24439C13.7059 3.24439 15.0531 3.84229 16.0666 4.92786C17.0801 6.01344 17.6383 7.45642 17.6383 8.98958C17.6383 10.5227 17.0801 11.9657 16.0666 13.0513C15.0531 14.1369 13.7059 14.7348 12.2746 14.7348Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                </div>
                                <div>{{ 'Dashboard' | trans }}</div>
                            </div>
                        </a>
                        <a class="dropdown-item header-dropdown-item" :href="linkSocial">
                            <div class="d-flex gap-20 align-items-center">
                                <div class="icon-container">
                                    <i class="fa fa-link"></i>
                                </div>
                                <div>{{ 'Linked Accounts' | trans }}</div>
                            </div>
                        </a>
                        <!-- TODO replace this with an actual button (exceedingly difficult right now due to css interference) -->
                        <a class="dropdown-item hover-danger logout-btn" @click.stop.prevent="logoutUser" href="#">
                            <div class="d-flex gap-20 align-items-center">
                                <div class="icon-container">
                                    <i
                                        :class="{
                                            'far fa-sign-out': !isLoggingOut,
                                            'fa fa-spinner fa-spin': isLoggingOut,
                                        }"
                                    ></i>
                                </div>
                                <div>{{ 'Logout' | trans }}</div>
                            </div>
                        </a>
                    </div>

                    <div v-if="isApi2Convert === true" class="d-lg-none pl-0 api2convert-items d-flex flex-column gap-5">
                        <a class="dropdown-item header-dropdown-item" :href="linkDocumentation">
                            <div class="d-flex gap-20 align-items-center">
                                <div class="icon-container">
                                    <i class="far fad fa-book"></i>
                                </div>
                                <div>{{ 'Documentation' | trans }}</div>
                            </div>
                        </a>

                        <a class="dropdown-item header-dropdown-item" :href="linkFileFormats">
                            <div class="d-flex gap-20 align-items-center">
                                <div class="icon-container">
                                    <i class="far fa fa-file-alt"></i>
                                </div>
                                <div>{{ 'File Formats' | trans }}</div>
                            </div>
                        </a>

                        <a class="dropdown-item header-dropdown-item" :href="linkBlog">
                            <div class="d-flex gap-20 align-items-center">
                                <div class="icon-container">
                                    <i class="far fa-blog"></i>
                                </div>
                                <div>{{ 'Blog' | trans }}</div>
                            </div>
                        </a>
                    </div>

                    <div class="pl-0 hidden-in-user-area d-flex flex-column gap-5">
                        <strong>{{ 'Billing' | trans }}</strong>

                        <a class="dropdown-item header-dropdown-item" :href="linkInvoices">
                            <div class="d-flex gap-20 align-items-center">
                                <div class="icon-container">
                                    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M0 0V18H11.0769V16.6154H1.38462V1.38462H8.30769V5.53846H12.4615V6.92308H13.8462V4.56923L13.6385 4.36154L9.48462 0.207692L9.27692 0H0ZM9.69231 2.35385L11.4923 4.15385H9.69231V2.35385ZM2.76923 6.92308V8.30769H11.0769V6.92308H2.76923ZM14.5385 8.30769V9.69231C13.3615 9.9 12.4615 10.8692 12.4615 12.1154C12.4615 13.5 13.5 14.5385 14.8846 14.5385H15.5769C16.1308 14.5385 16.6154 15.0231 16.6154 15.5769C16.6154 16.1308 16.1308 16.6154 15.5769 16.6154H13.1538V18H14.5385V19.3846H15.9231V18C17.1 17.7923 18 16.8231 18 15.5769C18 14.1923 16.9615 13.1538 15.5769 13.1538H14.8846C14.3308 13.1538 13.8462 12.6692 13.8462 12.1154C13.8462 11.5615 14.3308 11.0769 14.8846 11.0769H17.3077V9.69231H15.9231V8.30769H14.5385ZM2.76923 10.3846V11.7692H7.61539V10.3846H2.76923ZM9 10.3846V11.7692H11.0769V10.3846H9ZM2.76923 13.1538V14.5385H7.61539V13.1538H2.76923ZM9 13.1538V14.5385H11.0769V13.1538H9Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                </div>
                                <div>{{ 'Invoices' | trans }}</div>
                            </div>
                        </a>

                        <a v-if="shouldShowCredits" class="dropdown-item header-dropdown-item mobile-only" :href="linkCredits">
                            <div class="d-flex gap-20 align-items-center">
                                <div class="badge badge-warning">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 3.33334C9.72799 3.33334 11.324 3.64334 12.5133 4.17201C13.1067 4.43601 13.6293 4.76734 14.0113 5.16934C14.3973 5.57334 14.6667 6.08134 14.6667 6.66668V9.33334C14.6667 9.91868 14.3973 10.426 14.0113 10.8307C13.6293 11.2327 13.1073 11.564 12.5133 11.828C11.324 12.3567 9.72799 12.6667 8 12.6667C6.272 12.6667 4.676 12.3567 3.48666 11.828C2.89333 11.564 2.37066 11.2327 1.98866 10.8307C1.60266 10.4267 1.33333 9.91868 1.33333 9.33334V6.66668C1.33333 6.08134 1.60266 5.57401 1.98866 5.16934C2.37066 4.76734 2.89266 4.43601 3.48666 4.17201C4.676 3.64334 6.272 3.33334 8 3.33334ZM13.3333 8.72001C13.0833 8.88401 12.8067 9.03068 12.5133 9.16134C11.324 9.69001 9.72799 10 8 10C6.272 10 4.676 9.69001 3.48666 9.16134C3.20193 9.03648 2.92771 8.88889 2.66666 8.72001V9.33334C2.66666 9.48468 2.73333 9.67868 2.95466 9.91201C3.17933 10.148 3.53599 10.3913 4.02799 10.61C5.01066 11.0467 6.41466 11.3333 8 11.3333C9.58599 11.3333 10.9893 11.0467 11.972 10.61C12.464 10.3913 12.8207 10.148 13.0453 9.91201C13.2673 9.67868 13.3333 9.48468 13.3333 9.33334V8.72001ZM8 4.66668C6.414 4.66668 5.01066 4.95334 4.02799 5.39001C3.53599 5.60868 3.17933 5.85201 2.95466 6.08801C2.73266 6.32134 2.66666 6.51534 2.66666 6.66668C2.66666 6.81801 2.73333 7.01201 2.95466 7.24534C3.17933 7.48134 3.53599 7.72468 4.02799 7.94334C5.01066 8.38001 6.41466 8.66668 8 8.66668C9.58599 8.66668 10.9893 8.38001 11.972 7.94334C12.464 7.72468 12.8207 7.48134 13.0453 7.24534C13.2673 7.01201 13.3333 6.81801 13.3333 6.66668C13.3333 6.51534 13.2667 6.32134 13.0453 6.08801C12.8207 5.85201 12.464 5.60868 11.972 5.39001C10.9893 4.95401 9.58533 4.66668 8 4.66668Z" fill="#2E2E2E"/>
                                    </svg>
                                </div>
                                <div>{{ 'Credits' | trans }}</div>
                            </div>
                        </a>

                        <a class="dropdown-item" @click.stop.prevent="clickUpgradeButton" href="#" v-if="isApi2Convert">
                            <div class="d-flex gap-20 align-items-center">
                                <div class="icon-container">
                                    <i class="far fa-shopping-cart"></i>
                                </div>
                                <div>{{ 'Buy Credits' | trans }}</div>
                            </div>
                        </a>
                    </div>

                    <div class="d-flex flex-column gap-20" id="user-nav-top"></div>
                </template>
            </div>
        </div>
    </li>
</template>

<script>
import TransFilter from '../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { projectHelper } from '../../../misc/project-helper';
import { satGlobals } from '../../../../qaamgo/sat/helper/sat-globals';
import { cookieHelper } from '../../../../qaamgo/helper/cookie';
import { translatePath } from '../../../../qaamgo/sat/helper/translate-path';
import { translate } from '../../../../qaamgo/helper/translate';
import { pageNotification } from '../../../../qaamgo/helper/notify';
import { globalLogger } from '../../../../qaamgo/helper/global-logger';
import { csrfManager } from '../../../csrf/csrf-manager';
import ButtonWithLoadingState from '../../../../qaamgo/modules/sat/components/form/ButtonWithLoadingState';
import { registerPaymentModalHelper } from '../../modal/register_payment_flow/register-payment-modal-helper';
import { SESSION_STORAGE_USER, User } from '../../user';
import user from '../../../../qaamgo/modules/sat/components/aicreatorstudio/mixins/user.mixin';
import { userManager } from '../../user-manager';
import { EventBus as ResultPageEventBus } from '../../../../qaamgo/modules/sat/components/result_v2/events/event.bus';
import { EventBus as CreatorStudioEventBus } from '../../../../qaamgo/modules/sat/components/aicreatorstudio/events/event.bus';
import { useUserRegisterPaymentModalStore } from '../../../store/modules/user-register-payment-modal-store';
import CoinSVG from '../../../../qaamgo/modules/sat/components/form/icons/CoinSVG.vue';
import { EVENT_JOB_COMPLETE } from '../../../../qaamgo/modules/sat/components/result_v2/events/job.events';
import { EVENT_CREDITS_UPDATE } from '../../../../qaamgo/modules/sat/components/aicreatorstudio/events/credits.events';
export default {
    name: 'UserButtonsRegisteredView',
    components: { ButtonWithLoadingState, CoinSVG },
    props: {
        userRoles: {
            type: Array,
            default: [],
        },
        isUserRegistered: {
            type: Boolean,
            required: true,
        },
        isUserConfirmed: {
            type: Boolean,
            required: true,
        },
        isUserPremium: {
            type: Boolean,
            required: true,
        },
        isUserEducational: {
            type: Boolean,
            required: true,
        },
        userName: {
            type: String,
            required: true,
        },
        isUserEligibleForFreeTrial: {
            type: Boolean,
            default: false,
        },
        userProduct: {
            type: String,
            default: 'Premium',
        },
        useModalFlow: {
            type: Boolean,
            default: false,
        },
        enableFreeTrial: {
            type: Boolean,
            default: false,
        },
        freeTrialPeriod: {
            type: Number,
            default: -1,
        },
        links: {
            type: Object,
            default: {},
        },
    },
    mixins: [TransFilter, user],
    created() {
        this.availableCredits();
        ResultPageEventBus.$on(EVENT_JOB_COMPLETE, () => {
            this.availableCredits();
        });
        CreatorStudioEventBus.$on(EVENT_CREDITS_UPDATE, () => {
            this.availableCredits();
        });
    },
    computed: {
        shouldShowEducationalClaim() {
            return (
                !projectHelper.isApi2Convert() &&
                this.userRoles.includes(User.ROLE_USER_ELIGIBLE_FOR_EDUCATIONAL) &&
                !this.userRoles.includes(User.ROLE_USER_EDUCATIONAL)
            );
        },
        linkDashboard() {
            return this.links?.dashBoard ?? satGlobals.getAccountUrl() + translatePath('/user/dashboard');
        },
        linkRecentTasks() {
            return satGlobals.getAccountUrl() + translatePath('/user/tasks');
        },
        linkDashboardOrCredits() {
            return satGlobals.isCreditsEnabled()
                ? satGlobals.getAccountUrl() + translatePath('/user/payment/credits')
                : satGlobals.getAccountUrl() + translatePath('/user/dashboard');
        },
        linkSocial() {
            return this.links?.social ?? satGlobals.getAccountUrl() + translatePath('/user/social');
        },
        linkInvoices() {
            return this.links?.invoices ?? satGlobals.getAccountUrl() + translatePath('/user/payment/history');
        },
        linkCredits() {
            return satGlobals.getAccountUrl() + translatePath('/user/payment/credits');
        },
        linkLogOut() {
            return this.links?.logOut ?? satGlobals.getAccountUrl() + translatePath('/logout');
        },
        linkUpgradeButton() {
            let link = this.links?.register ?? satGlobals.getMainUrl() + translatePath('/register');

            // if (this.enableFreeTrial && this.isUserEligibleForFreeTrial) {
            //   return link;
            // }

            return link;
        },
        descriptionUpgradeBox() {
            let text = translate('Get premium and use all our tools to their fullest');

            if (this.enableFreeTrial && this.isUserEligibleForFreeTrial) {
                text = translate('Try premium and use all our tools to their fullest');
            }

            if (this.shouldShowEducationalClaim) {
                text = translate(
                    'Your email address belongs to a school and you are eligible for a <strong>free educational premium account.</strong>'
                );
            }

            return text;
        },
        textUpgradeButton() {
            let text = translate('Upgrade now');

            if (this.enableFreeTrial && this.isUserEligibleForFreeTrial) {
                text = translate('Try %count% days free', { '%count%': this.freeTrialPeriod });
            }

            if (this.shouldShowEducationalClaim) {
                text = translate('Claim now');
            }

            return text;
        },
        textSaleButton() {
            return translate('Click Here To Get %discount% Off Today', {
                '%discount%': '70%',
            });
        },
        linkDocumentation() {
            return satGlobals.getMainUrl() + '/docs/index.html';
        },
        linkFileFormats() {
            return satGlobals.getMainUrl() + '/file-formats';
        },
        linkBlog() {
            return 'https://blog.online-convert.com/tag/api/';
        },
        showSale() {
            return (this.isPDF2Go || this.isOc) && !this.isUserPremium && satGlobals.getIsSale();
        },
        linkSale() {
            return satGlobals.getSaleUrl();
        },
        shouldShowUpgradeBox() {
            if (this.showSale) {
                return false;
            }

            if (this.isApi2Convert) {
                return false;
            }

            if (!this.isUserRegistered) {
                return false;
            }

            if (!this.isUserConfirmed && this.shouldShowEducationalClaim) {
                return false;
            }

            if (
                this.shouldShowEducationalClaim &&
                this.userRoles.includes(User.ROLE_USER_NEEDS_VERIFICATION_FOR_EDUCATIONAL)
            ) {
                return false;
            }

            return true;
        },
        shouldShowBuyMore() {
            if (this.isUserPremium && satGlobals.isCreditsEnabled() && !this.shouldShowUpgradeBox) {
                return true;
            }
        },
        shouldShowCredits() {
            return satGlobals.isCreditsEnabled();
        },
        userBadgeBg() {
            if (this.isUserEducational) {
                return 'education-user-badge ';
            } else if (this.isUserPremium) {
                if (this.userProduct === 'starter') {
                    return 'starter-user-badge';
                } else if (this.userProduct === 'pro') {
                    return 'pro-user-badge';
                } else if (this.userProduct === 'ultimate') {
                    return 'ultimate-user-badge';
                } else {
                    return 'ultimate-user-badge';
                }
            } else {
                return 'free-user-badge';
            }
        },
    },
    methods: {
        clickUpgradeButton() {
            const store = useUserRegisterPaymentModalStore();
            if (this.shouldShowEducationalClaim) {
                userManager.claimEducationalAccessAndRedirectToSuccessPage();

                return;
            }

            if (this.useModalFlow) {
                if (satGlobals.isMultipleProductsEnabled()) {
                    store.setCanGoBack(true);
                }
                registerPaymentModalHelper.openUpgrade();
                return;
            }

            window.location = this.linkUpgradeButton;
        },
        clickBuyMoreCredits() {
            if (satGlobals.isCreditsInAllSatsEnabled()) {
                registerPaymentModalHelper.openUpgrade();
            } else {
                registerPaymentModalHelper.openForPricingPremium();
            }
        },
        async logoutUser() {
            if(satGlobals.getEnv() === 'dev_docker'){
                const baseDomain = satGlobals.getBaseDomain()
                //set ttl to negative to clear cookie
                cookieHelper.setCookie('x-oc-download-password', '', -9999999, '/',baseDomain)
            }
            this.isLoggingOut = true;

            // TODO add setTimeout, setting isLoggingOut=false to prevent broken state when redirect is cancelled?

            try {
                const csrfToken = await csrfManager.getCsrfLogout();

                // clear meData from session storage to prevent page load weirdness/cls issues
                sessionStorage.removeItem(SESSION_STORAGE_USER);

                try {
                    await eventBus.emit('user-buttons-clear-localstorage-user');
                } catch (e) {}

                window.location = this.linkLogOut + '?_csrf=' + csrfToken;
            } catch (error) {
                this.isLoggingOut = false;

                pageNotification.showGenericErrorMessage();

                globalLogger.log('userButtons - logout csrf request failed', error);
            }
        },
        handleShowDropDown() {
            let dropdownHover = document.getElementById('dropdown-menu-hover');
            if (dropdownHover) {
                dropdownHover.classList.add('dropdown-menu-hover-effect');
            }
            this.showDropDown = true;
        },
        handleHideDropDown() {
            let dropdownHover = document.getElementById('dropdown-menu-hover');
            if (dropdownHover) {
                dropdownHover.classList.remove('dropdown-menu-hover-effect');
            }
            // this.showDropDown = false;
        },
        handleCreditsNav() {
            window.location.href = this.linkDashboardOrCredits;
        },

        async availableCredits() {
            await userManager.getFreshUser();
            const getUser = await userManager.getUser();
            this.availableCredit = getUser.getAvailableCredits();
        },
    },
    data() {
        return {
            isSatAdmin: projectHelper.isSatAdmin(),
            isApi2Convert: projectHelper.isApi2Convert(),
            isPDF2Go: projectHelper.isPdf2go(),
            isOc: projectHelper.isOnlineConvert(),
            isImg2Go: projectHelper.isImg2go(),
            isCreditsInAllSatsEnabled: satGlobals.isCreditsInAllSatsEnabled(),
            isLoggingOut: false,
            showDropDown: false,
            availableCredit: 0,
        };
    },
};
</script>

<style lang="scss" scoped>
.badge-container {
    margin-right: -12px !important;
}
.user-badge {
    border: 2px;
    border-radius: 4px;
    height: 42px;
    min-width: 115px;
    display: flex;
    justify-content: space-between;
    padding: 2px;
    gap: 2px;
}
.menu-badge {
    gap: 10px;
    font-size: 17.5px;
    color: #1e1e1e;
}
.free-user-badge {
    background-color: #e0e0e0;
    span {
        font-size: 10px;
        color: #1e1e1e;
    }
}
.starter-user-badge {
    background-color: #7759c2;
    span {
        color: #fff;
        font-size: 10px;
    }
}
.pro-user-badge {
    background-color: #1b5e20;
    span {
        color: #fff;
        font-size: 10px;
    }
}
.ultimate-user-badge {
    background-color: #1e1e1e;
    span {
        color: #fff;
        font-size: 10px;
    }
}
.education-user-badge {
    background-color: #7b1fa2;
    span {
        color: #fff;
        font-size: 10px;
    }
}
.user-credits {
    background: #ffaa00;
    color: #1e1e1e;
    border-radius: 3px 0px 0px 0px;
    padding: 0px 5px 0px 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
}
.icon-container {
    display: flex;
    width: 27.451px;
    height: 30.588px;
    padding: 2px;
    justify-content: center;
    align-items: center;
    gap: 10px;
}
.main-user-dropdown [data-user-button-upgrade]:active {
    background: #ffaa00 !important;
}
.dropdown-item {
    display: flex;
    padding: 10px 0 9.412px 17px !important;
    align-items: center;
    align-self: stretch;
    border-radius: 5px;
    display: flex;
    align-items: center;
}
.user-icon {
    padding: 5px 7px 5px 7px;
    border-radius: 0px 4px 4px 0px;
}
.gap-30 {
    gap: 30px;
}
.tools-container li a {
    padding: 0px;
}
.header-dropdown-item {
    color: black;
}
.header-dropdown-item:hover {
    background: #1266f1;
    color: #fff;
    svg {
        color: #fff;
    }
    div {
        color: #fff;
    }
}
@media (max-width: 567px) {
    .tools-container li a {
        padding: 0px 12px;
    }
    .badge-container {
        margin-right: 0px !important;
    }
}
@media (max-width: 385px) {
    .tools-container li a {
        padding: 0px 0px;
    }
}
@media (min-width: 1049px) {
    .mobile-only {
      display: none !important;
    }
}
</style>
